import { api } from '../config/api';

export const orderService = {
  // ═══ FULL ORDERS ═══

  getFullOrders: async (params = {}) => {
    const qp = new URLSearchParams();
    if (params.search) qp.append('search', params.search);
    if (params.status) qp.append('status', params.status);
    if (params.client_id) qp.append('client_id', params.client_id);
    const qs = qp.toString();
    return await api.get(`/orders/full-orders${qs ? `?${qs}` : ''}`);
  },

  getFullOrder: async (id) => {
    return await api.get(`/orders/full-orders/${id}/`);
  },

  createFullOrder: async (data) => {
    return await api.post('/orders/full-orders/', data);
  },

  updateFullOrder: async (id, data) => {
    return await api.patch(`/orders/full-orders/${id}/`, data);
  },

  deleteFullOrder: async (id) => {
    return await api.delete(`/orders/full-orders/${id}/`);
  },

  generatePOs: async (fullOrderId, groupByFactory = true) => {
    return await api.post(`/orders/full-orders/${fullOrderId}/generate-pos`, {
      group_by_factory: groupByFactory,
    });
  },

  // ═══ FULL ORDER ITEMS ═══

  getFullOrderItems: async (orderId) => {
    return await api.get(`/orders/full-orders/${orderId}/items/`);
  },

  createFullOrderItem: async (orderId, data) => {
    return await api.post(`/orders/full-orders/${orderId}/items/`, data);
  },

  updateFullOrderItem: async (orderId, itemId, data) => {
    return await api.patch(`/orders/full-orders/${orderId}/items/${itemId}`, data);
  },

  deleteFullOrderItem: async (orderId, itemId) => {
    return await api.delete(`/orders/full-orders/${orderId}/items/${itemId}`);
  },

  // ═══ PURCHASE ORDERS ═══

  getPurchaseOrders: async (params = {}) => {
    const qp = new URLSearchParams();
    if (params.search) qp.append('search', params.search);
    if (params.fty_pi_status) qp.append('fty_pi_status', params.fty_pi_status);
    if (params.full_order_id) qp.append('full_order_id', params.full_order_id);
    if (params.client_id) qp.append('client_id', params.client_id);
    const qs = qp.toString();
    return await api.get(`/orders/purchase-orders${qs ? `?${qs}` : ''}`);
  },

  getPurchaseOrder: async (id) => {
    return await api.get(`/orders/purchase-orders/${id}/`);
  },

  createPurchaseOrder: async (data) => {
    return await api.post('/orders/purchase-orders/', data);
  },

  updatePurchaseOrder: async (id, data) => {
    return await api.patch(`/orders/purchase-orders/${id}/`, data);
  },

  deletePurchaseOrder: async (id) => {
    return await api.delete(`/orders/purchase-orders/${id}/`);
  },

  // ═══ PURCHASE ORDER ITEMS ═══

  getPurchaseOrderItems: async (poId) => {
    return await api.get(`/orders/purchase-orders/${poId}/items/`);
  },

  createPurchaseOrderItem: async (poId, data) => {
    return await api.post(`/orders/purchase-orders/${poId}/items/`, data);
  },

  updatePurchaseOrderItem: async (poId, itemId, data) => {
    return await api.patch(`/orders/purchase-orders/${poId}/items/${itemId}`, data);
  },

  deletePurchaseOrderItem: async (poId, itemId) => {
    return await api.delete(`/orders/purchase-orders/${poId}/items/${itemId}`);
  },

  // ═══ CHOICES ═══

  getChoices: async () => {
    return await api.get('/orders/full-orders/choices');
  },
};
